// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hospitals.svelte-1rc0424.svelte-1rc0424{display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}.hospitals.svelte-1rc0424 .hospital.svelte-1rc0424{background-color:#F0F3F6;border-radius:2px;padding:15px;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
